(function () {
  /**
   * Nike-style cross-option variant availability.
   *
   * When the user picks a value in one option group (e.g. Color = "Black"),
   * every OTHER option group updates to reflect which values still lead to
   * an available variant given that selection.
   *
   * A value is disabled only when no available variant exists that matches
   * ALL currently-selected values in every other group PLUS that value.
   */

  function getSelectedValues(fieldsets) {
    return fieldsets.map(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function refreshAllFieldsets(container) {
    var jsonEl = container.querySelector('[type="application/json"]');
    if (!jsonEl) return;

    var variantData;
    try {
      variantData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var fieldsets = Array.from(container.querySelectorAll("fieldset"));
    var selectedValues = getSelectedValues(fieldsets);

    fieldsets.forEach(function (fieldset, fieldsetIndex) {
      var inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;

      inputs.forEach(function (input) {
        var candidateValue = input.value;

        // Check if any available variant matches this candidate value
        // AND all currently-selected values in the OTHER option groups
        var hasAvailable = variantData.some(function (variant) {
          if (!variant.available) return false;
          if (variant.options[fieldsetIndex] !== candidateValue) return false;

          // Check that this variant matches selected values in all other groups
          for (var i = 0; i < selectedValues.length; i++) {
            if (i === fieldsetIndex) continue;
            if (selectedValues[i] !== null && variant.options[i] !== selectedValues[i]) return false;
          }
          return true;
        });

        // Always ensure the input is enabled (clickable) — we use
        // data-sold-out + CSS styling instead of disabled, so users
        // can still select sold-out options and trigger Back in Stock.
        input.disabled = false;

        if (!hasAvailable) {
          input.dataset.soldOut = 'true';
        } else {
          delete input.dataset.soldOut;
        }
      });

      // Apply sold-out styling to labels
      inputs.forEach(function (input) {
        var label = input.nextElementSibling;
        if (!label) return;
        if (input.dataset.soldOut) {
          label.classList.add('variant-label--sold-out');
        } else {
          label.classList.remove('variant-label--sold-out');
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("variant-radios").forEach(function (vr) {
      refreshAllFieldsets(vr);
      vr.addEventListener("change", function () {
        setTimeout(function () { refreshAllFieldsets(vr); }, 0);
      });
    });
  });
})();
